/** d3-style nice ticks for the Cash Report close series. Axis labels only — not cents. */

const E10 = Math.sqrt(50)
const E5 = Math.sqrt(10)
const E2 = Math.sqrt(2)

function tickIncrement(start, stop, count) {
  const step = (stop - start) / Math.max(0, count)
  const power = Math.floor(Math.log(step) / Math.LN10 + 1e-12)
  const error = step / 10 ** power
  const nice = error >= E10 ? 10 : error >= E5 ? 5 : error >= E2 ? 2 : 1
  return power >= 0 ? nice * 10 ** power : -(10 ** -power) / nice
}

export function niceAxisTicks(min, max, count = 4) {
  let start = Number(min)
  let stop = Number(max)
  if (!Number.isFinite(start) || !Number.isFinite(stop)) return [0]
  if (start >= 0) start = 0
  if (start === stop) return start >= 0 ? [0, 1] : [start]
  let reverse = false
  if (stop < start) {
    const swap = start
    start = stop
    stop = swap
    reverse = true
  }
  const step = tickIncrement(start, stop, count)
  if (!step || !Number.isFinite(step)) return [0]
  const ticks = []
  if (step > 0) {
    let r0 = Math.round(start / step)
    let r1 = Math.round(stop / step)
    if (r0 * step < start) r0 += 1
    if (r1 * step > stop) r1 -= 1
    for (let i = r0; i <= r1; i += 1) ticks.push(i * step)
  }
  if (!ticks.length) ticks.push(start >= 0 ? 0 : start, stop)
  return reverse ? ticks.reverse() : ticks
}

/** Min is $0 unless the close series or cushion band goes below zero. */
export function cashReportChartDomain(closes, cushion = 0) {
  if (!closes.length) return { min: 0, max: Math.max(cushion, 1) }
  const seriesMin = Math.min(...closes, cushion)
  const seriesMax = Math.max(...closes, cushion)
  return {
    min: seriesMin < 0 ? seriesMin : 0,
    max: Math.max(seriesMax, 1),
  }
}
